export enum SolutionStatus {
  NotProvided,
  Successful,
  Failed,
}
